import { api } from './api';
import { LoginRequest, AuthResponse } from '../types/api.types';

export const authApi = {
    login: (email: string, password: string): Promise<AuthResponse> =>
        api.post('/admin/login', { email, password }).then(res => res.data),
};